import Header, { HeaderAction } from './Header'

const Page = ({
  actions,
  children,
}: {
  actions?: HeaderAction[]
  children: JSX.Element | JSX.Element[]
}) => {
  return (
    <>
      <Header actions={actions} />
      <div className="mt-4 mx-4 mb-4">{children}</div>
    </>
  )
}

export default Page
